import "./style.css"

export const Card = ({ img, text, backgroundColor, onClick }) => {
	return (
		<div
			className="card"
			style={{ backgroundColor: `${backgroundColor}` }}
			onClick={onClick}
		>
			<img className="card-image" src={img} alt={text} />
			<p className="card-text">{text}</p>
		</div>
	)
}
